export default {
  brancoTema: '#ffebd9',
  vermelhoEscuro: '#E66767',
  bgClaro: '#fff8f2',
  branco: '#fff',
  preto: '#000',
  frmTextColor: '#4b4b4b'
}
